module.exports = __webpack_public_path__ + "img/szhxNo3_2.616fe943.png";